import React from "react";
import styled from "styled-components";

const Tile = styled.button`
	background: #fff;
	border: 1px solid var(--lcds-border);
	border-radius: 12px;
	padding: 28px 20px 22px;
	width: 100%;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	font-family: inherit;
	transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
	box-shadow: 0 1px 3px rgba(31, 42, 48, 0.06);
	&:hover,
	&:focus-visible {
		transform: translateY(-2px);
		border-color: var(--lcds-teal);
		box-shadow: 0 6px 18px rgba(42, 56, 64, 0.12);
		outline: none;
	}
	img {
		width: 96px;
		height: 96px;
		object-fit: contain;
	}
	.icon {
		width: 96px;
		height: 96px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 64px;
		color: var(--lcds-navy);
	}
	h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 600;
		color: var(--lcds-navy);
		text-align: center;
	}
	p {
		margin: -8px 0 0;
		color: var(--lcds-muted);
		font-size: 13px;
		text-align: center;
	}
`;

export const TileGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 20px;
	max-width: ${(p) => p.$maxWidth || "1000px"};
	margin: 0 auto;
`;

/** Clickable tile with an icon (image src or React node), title and optional description. */
const ScenarioCard = ({ icon, title, description, onClick }) => (
	<Tile type="button" onClick={onClick}>
		{typeof icon === "string" ? <img src={icon} alt="" /> : <div className="icon">{icon}</div>}
		<h3>{title}</h3>
		{description && <p>{description}</p>}
	</Tile>
);

export default ScenarioCard;
